import { ComponentEvents } from '../../../../global/interfaces/component.interface';

export const AtomQuantitySelectorEvents: ComponentEvents = {
	/** The custom event when the qty changes on the atom */
	quantityChangeEvent: 'quantityChanged',
};
